export default `
    <a
         id="#= data.id || "" #"
        # if (data.disabled) { # disabled # } #
         class="link bind-label #= data.classes # #=data.bsc||""#"
        # if (data.bindLabel) { # data-bind="#= data.bindLabel #"  # } #
        # if (data.toolTip) { # title="#= data.toolTip #" # } #
        # if (data.href) { # href="#= data.href #" # } #
        # if (data.openNewTab) { # target="_blank" # } #
    >
    </a>
`;
